import {
    useMemo,
} from 'react'
import {
    useSkyNetNavigate, SkyNetRoutesConfig, createRoutesConfig, RoutesConfig,
} from 'app/SkyNetRoutes/index'
import {
    CommonRoutes,
} from 'app/enums/common.enums'
import useCreateSkyNetDomainRoutes from 'app/shared-components/SkyNetDomain/useCreateSkyNetDomainRoutes'
import {
    App,
    AQuotesTab,
    PricingDomains,
    ContractBasisTabs,
    LaneGroupsTabs,
    AssingPricingSubRoutes,
} from 'app/enums/domain.enums'

export default function usePricingRoutes() {
    const skyNetNavigate = useSkyNetNavigate()
    const SkyNetDomainRoutes = useCreateSkyNetDomainRoutes()()

    return useMemo(() => {
        const config: SkyNetRoutesConfig = {
            path: [App.Pricing],
            PricingDashboard: {
                route: PricingDomains.PricingDashboard,
            },
            ContractBasis: {
                route: PricingDomains.ContractBasis,
                ContractBasis: {
                    route: ContractBasisTabs.ContractBasis,
                    via: SkyNetDomainRoutes.All.Edit as RoutesConfig,
                },
                AdditionalFees: {
                    route: ContractBasisTabs.AdditionalFees,
                    via: SkyNetDomainRoutes.All.Edit as RoutesConfig,
                    params: [
                        {
                            name: 'id',
                        },
                        {
                            name: 'action',
                        },
                    ],
                },
                AdditionalFeesCopy: {
                    route: ContractBasisTabs.AdditionalFees,
                    via: SkyNetDomainRoutes.All.Edit,
                    params: [
                        {
                            name: 'id',
                            required: true,
                        },
                        {
                            name: 'action',
                        },
                    ],
                },
                LongTermLeaseFees: {
                    route: ContractBasisTabs.LongTermLeaseFees,
                    via: SkyNetDomainRoutes.All.Edit,
                    params: [
                        {
                            name: 'id',
                        },
                        {
                            name: 'action',
                        },
                    ],
                },
                LaneGroups: {
                    route: ContractBasisTabs.LaneGroups,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                CreateQuote: {
                    route: ContractBasisTabs.CreateQuote,
                    via: SkyNetDomainRoutes.All.Edit,
                },
            },
            LaneGroups: {
                route: PricingDomains.LaneGroups,
                Overview: {
                    route: CommonRoutes.Overview,
                    via: SkyNetDomainRoutes.All.Edit,
                    params: [{
                        name: 'copy',
                    }],
                },
                Copy: {
                    route: CommonRoutes.Overview,
                    via: SkyNetDomainRoutes.All.Edit,
                    params: [{
                        name: 'copy',
                    }],
                },
                Lanes: {
                    route: LaneGroupsTabs.Lanes,
                    via: SkyNetDomainRoutes.All.Edit,
                    params: [
                        {
                            name: 'actionId',
                        },
                        {
                            name: 'action',
                        },
                    ],
                },
                LaneFees: {
                    route: LaneGroupsTabs.LaneFees,
                    via: SkyNetDomainRoutes.All.Edit,
                    params: [
                        {
                            name: 'feesId',
                        },
                        {
                            name: 'feesAction',
                        },
                    ],
                },
                AdditionalFeesCopy: {
                    route: ContractBasisTabs.AdditionalFees,
                    via: SkyNetDomainRoutes.All.Edit,
                    params: [
                        {
                            name: 'feesId',
                            required: true,
                        },
                        {
                            name: 'feesAction',
                        },
                    ],
                },
                ChangeHistory: {
                    route: CommonRoutes.ChangeHistory,
                    via: SkyNetDomainRoutes.All.Edit,
                },
            },
            LaneFees: {
                route: PricingDomains.LaneFees,
                Overview: {
                    route: CommonRoutes.Overview,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                DataUpdate: {
                    route: CommonRoutes.DataUpdate,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                Copy: {
                    route: CommonRoutes.Overview,
                    via: SkyNetDomainRoutes.All.Edit,
                    params: [{
                        name: 'copy',
                    }],
                },
                ChangeHistory: {
                    route: CommonRoutes.ChangeHistory,
                    via: SkyNetDomainRoutes.All.Edit,
                },
            },
            Lanes: {
                route: PricingDomains.Lanes,
            },
            AlLogisticPricing: {
                route: PricingDomains.AlLogisticPricing,
                Update: {
                    route: CommonRoutes.Update,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                Copy: {
                    route: CommonRoutes.Update,
                    via: SkyNetDomainRoutes.All.Edit,
                    params: [{
                        name: 'copy',
                    }],
                },
            },
            AlLeasePricing: {
                route: PricingDomains.AlLeasePricing,
                Update: {
                    route: CommonRoutes.Update,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                Copy: {
                    route: CommonRoutes.Update,
                    via: SkyNetDomainRoutes.All.Edit,
                    params: [{
                        name: 'copy',
                    }],
                },
            },
            AQuotes: {
                route: PricingDomains.AQuotes,
                Overview: {
                    route: CommonRoutes.Overview,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                Update: {
                    route: CommonRoutes.DataUpdate,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                AssignQuote: {
                    route: AQuotesTab.AssignQuote,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                ReviewGroup: {
                    route: AQuotesTab.ReviewGroup,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                AssignPricing: {
                    route: AQuotesTab.AssignPricing,
                    via: SkyNetDomainRoutes.All.Edit,
                    params: [{
                        name: 'laneGroupId',
                    }],
                    LaneFees: {
                        route: AssingPricingSubRoutes.LaneFees,
                        params: [
                            {
                                name: 'feesId',
                            },
                            {
                                name: 'feesAction',
                            },
                        ],
                    },
                },
                AwardReject: {
                    route: AQuotesTab.AwardReject,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                QuotePdf: {
                    route: AQuotesTab.QuotePdf,
                    via: SkyNetDomainRoutes.All.Edit,
                },
            },
        }

        return createRoutesConfig(skyNetNavigate)(config)
    }, [
        SkyNetDomainRoutes,
        skyNetNavigate,
    ])
}
